import { render, staticRenderFns } from "./NoPicture.vue?vue&type=template&id=8a6bf6d2&"
import script from "./NoPicture.vue?vue&type=script&lang=ts&"
export * from "./NoPicture.vue?vue&type=script&lang=ts&"
import style0 from "./NoPicture.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports